import {ResourceType} from "@/store/place/types";

export interface ExchangeState {
}

export class ExchangeTerms {
    percentageOfTotal!: number;
    exchangePrices!: ExchangePrice[]
}

export class ExchangePrice {
    targetType!: ResourceType;
    fromType!: ResourceType;
    priceForOne!: number;
}

export class ExchangeAmount {
    targetType!: ResourceType;
    amount!: number;
    exchangePortions!: ExchangePortion[];

    constructor(targetType: ResourceType, amount: number) {
        this.targetType = targetType;
        this.amount = amount;
        this.exchangePortions = [];
    }
}

export class ExchangePortion {
    type!: ResourceType;
    amount!: number;

    constructor(type: ResourceType, amount: number) {
        this.type = type;
        this.amount = amount;
    }
}
